import { TerminateTreatmentRequestPayload } from "@/data/payload/treatment/pause-treatment-request-payload";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { CacheInvalidator } from "@/utils/cache/cache-invalidator";

export class TerminateTreatmentUsecase {
  //MARK:- Constructor
  constructor(
    private readonly treatmentRepo: TreatmentRepository,
    private readonly patientListCache?: CacheInvalidator
  ) {}

  //MARK:- execute
  async execute(treatmentInfoUuid: string): Promise<SATResult<void, SATError>> {
    const payload: TerminateTreatmentRequestPayload = { treatmentInfoUuid };
    const result = await this.treatmentRepo.terminateTreatment(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    // 환자 목록 캐시가 변경 전 데이터를 보여주지 않도록 비움
    this.patientListCache?.invalidate();
    return SATResult.success(void 0);
  }

  /**
   * 여러 치료를 주어진 순서대로 하나씩 취소합니다. 하나라도 실패하면 거기서 멈춥니다.
   * 뒤에 이어 붙은 시작 전 치료를 늦은 것부터 넘기고 마지막에 대상 치료를 넘기면,
   * 중간에 실패해도 남은 치료 사이에 빈 기간이 생기지 않습니다.
   */
  async executeInOrder(treatmentInfoUuids: string[]): Promise<SATResult<void, SATError>> {
    for (const treatmentInfoUuid of treatmentInfoUuids) {
      const result = await this.execute(treatmentInfoUuid);
      if (result.isFailure) {
        return result;
      }
    }
    return SATResult.success(void 0);
  }
}
